(function (namespace, $) {
	"use strict";

	var AppMessage = function () {
		var o = this;
		$(document).ready(function () {
			o.initialize();
		});
	};

	var p = AppMessage.prototype;

	p.initialize = function () {};

	p._error = function (msg) {
		toastr.clear();

		toastr.options.closeButton = true;
		toastr.options.progressBar = false;
		toastr.options.debug = false;
		toastr.options.positionClass = "toast-bottom-full-width";
		toastr.options.showDuration = 333;
		toastr.options.hideDuration = 333;
		toastr.options.timeOut = 5000;
		toastr.options.extendedTimeOut = 2000;
		toastr.options.showEasing = "swing";
		toastr.options.hideEasing = "swing";
		toastr.options.showMethod = "slideDown";
		toastr.options.hideMethod = "slideUp";

		toastr.error(msg, "<strong>Whoops!</strong> Houve algum problema!");
	};

	p._warning = function (msg) {
		toastr.clear();

		toastr.options.closeButton = true;
		toastr.options.progressBar = false;
		toastr.options.debug = false;
		toastr.options.positionClass = "toast-bottom-full-width";
		toastr.options.showDuration = 333;
		toastr.options.hideDuration = 333;
		toastr.options.timeOut = 5000;
		toastr.options.extendedTimeOut = 2000;
		toastr.options.showEasing = "swing";
		toastr.options.hideEasing = "swing";
		toastr.options.showMethod = "slideDown";
		toastr.options.hideMethod = "slideUp";

		toastr.warning(msg);
	};

	p._success = function (msg) {
		toastr.clear();

		toastr.options.closeButton = true;
		toastr.options.progressBar = false;
		toastr.options.debug = false;
		toastr.options.positionClass = "toast-bottom-full-width";
		toastr.options.showDuration = 333;
		toastr.options.hideDuration = 333;
		toastr.options.timeOut = 6000;
		toastr.options.extendedTimeOut = 1000;
		toastr.options.showEasing = "swing";
		toastr.options.hideEasing = "swing";
		toastr.options.showMethod = "slideDown";
		toastr.options.hideMethod = "slideUp";

		toastr.success(msg);
	};

	p._info = function (msg, title) {
		toastr.clear();

		toastr.options.closeButton = true;
		toastr.options.progressBar = false;
		toastr.options.debug = false;
		toastr.options.positionClass = "toast-bottom-full-width";
		toastr.options.showDuration = 333;
		toastr.options.hideDuration = 333;
		toastr.options.timeOut = 5000;
		toastr.options.extendedTimeOut = 2000;
		toastr.options.showEasing = "swing";
		toastr.options.hideEasing = "swing";
		toastr.options.showMethod = "slideDown";
		toastr.options.hideMethod = "slideUp";

		toastr.info(msg, title);
	};

	window.gpssat.AppMessage = new AppMessage();
})(window.gpssat, jQuery);
